/**
 * Display title for a creation. Presented files carry a caption/filename; a
 * GENERATED media row (source 'studio') carries neither: its only honest text
 * is the creative brief it was generated from, so the title is a squeeze of
 * that brief: first sentence, capped at a word boundary. Without this, every
 * generated image card read "Untitled" (founder, 08-08).
 *
 * Shared so the server names a creation the way the web does (the share dialog,
 * Shared with me and the share email read the server's name). The brief is the
 * task_artifacts `prompt` column (artifact-store rowToArtifact).
 */

const TITLE_MAX = 64;

/** First sentence of the brief, word-boundary capped. Null when there is no
 *  usable text, so callers keep their own fallback chain. */
export function briefTitle(brief: string | null | undefined): string | null {
  const text = (brief ?? '').trim();
  if (!text) return null;
  const firstLine = text.split('\n', 1)[0]!.trim();
  // First "." / "!" / "?" that ends a sentence (followed by space or end),
  // no lookbehind, so decimals like "16.9" never split.
  const sentenceMatch = firstLine.match(/^[\s\S]*?[.!?](?=\s|$)/);
  let title = (sentenceMatch ? sentenceMatch[0] : firstLine)
    .replace(/[.!?]+$/, '')
    .trim();
  if (title.length > TITLE_MAX) {
    const cut = title.slice(0, TITLE_MAX + 1);
    const lastSpace = cut.lastIndexOf(' ');
    title = (
      lastSpace > TITLE_MAX / 2
        ? cut.slice(0, lastSpace)
        : cut.slice(0, TITLE_MAX)
    ).replace(/[\s,;:]+$/, '');
  }
  return title || null;
}

export function creationTitle(a: {
  caption?: string | null;
  filename?: string | null;
  brief?: string | null;
}): string {
  return a.caption || a.filename || briefTitle(a.brief) || 'Untitled';
}
